// extracted by mini-css-extract-plugin
export default {"detalle":"PopupExpulsion_detalle__vX38E"};